export { DiningReservationTemplate } from './DiningReservationTemplate';
export type {
  DiningReservationLabels,
  DiningReservationMenuOption,
  DiningReservationRestaurant,
  DiningReservationTemplateProps,
} from './DiningReservationTemplate.types';
